<template>
  <div class="mask">
    <div class="maskContent">
      <div class="main">
        <img src="../../assets/close.png" class="closeImg" @click="linkBack()">
        <van-cell-group>
          <van-cell title="经销商名称" :value="dd.cName" />
          <van-cell title="手机号" :value="dd.cMobile"/>
          <van-cell title="经销商编号" :value="dd.cSMCustomerId" />
          <van-cell title="省市区" :value="dd.cProvince+dd.cCity+dd.cCounty" />
          <van-cell title="联系人" :value="dd.cContact" />
          <van-cell title="联系地址" :value="dd.cAddress" />
        </van-cell-group>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { CellGroup, Cell } from "vant";

export default {
  data() {
    return {
      dd:""
    };
  },
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
  },
  methods: {
    linkBack() {
      this.$router.go(-1);
    },
  },
  created:function(){
    var _this=this;
    var dd={
      id:this.$route.query.id,
      ticket:sessionStorage.getItem("ticket")
    }
    this.$get("/api/PhoneAPI/GetCustomerInfoModel", dd)
        .then((res) => {
         _this.dd=res.Content;
        })
        .catch((err) => {
          console.log(err);
        });
  }
};
</script>
<style scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 375px;
  background: rgba(0, 0, 0, 0.4);
  height: 100vh;
  z-index: 999;
}
.maskContent {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main {
  width: 300px;
  height: 320px;
  background: white;
  padding: 10px;text-align: left;
  border-radius: 5px;
}
.closeImg{
  position: absolute;background: white;width: 20px;height: 20px;
  z-index: 1000;margin-left: 296px;border-radius: 50%;margin-top: -18px;
}
</style>
